import React from 'react';

import { Attribution, withErrorBoundary } from '@confluence/error-boundary';
import { LoadableLazy } from '@confluence/loadable';

const TrialFlagsLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TrialComponentsFlags" */ './TrialFlags/TrialFlags'
			)
		).TrialFlags,
});

export const TrialFlags = withErrorBoundary({
	attribution: Attribution.GROWTH_LUNA,
})(() => <TrialFlagsLoadable />);

export const PremiumLozengeLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumLozenge" */ '../src/Lozenge/PremiumLozenge'
			)
		).PremiumLozenge,
});

export { default as PremiumLozengeImage } from './Lozenge/premiumLozenge.svg';

export type { ActionMenuProps } from './ActionMenu/ActionMenu';

export const LazyAutoUpgradeAwarenessModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AutoUpgradeAwarenessModal" */ './AutoUpgradeAwarenessModal/AutoUpgradeAwarenessModal'
			)
		).AutoUpgradeAwarenessModal,
});

export { useGetUserCount } from './AutoUpgradeAwarenessModal/hooks/useGetUserCount';

export const ReverseTrialLozengeExperiment = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReverseTrialLozengeExperiment" */ './ReverseTrialLozengeExperiment/ReverseTrialLozenge'
			)
		).ReverseTrialLozengeWithErrorBoundary,
});

export const ReverseTrialLozengeListItemExperiment = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReverseTrialLozengeListItemExperiment" */ './ReverseTrialLozengeExperiment/ReverseTrialListItem'
			)
		).ReverseTrialListItemWithErrorBoundary,
});
